import React, { useContext } from 'react';
import classnames from 'classnames';
import { Activities, attraqtTracker } from '../../../../analytics/attraqt/attraqtTracker';
import { ListerContext } from '../../listerContext';
import useListerApi from '../../listerApiHooks';
import { FacetData, FacetValueData } from '../../../../types';
import styles from './facetsCategory.module.pcss';
import Facet from './facet';
import ScrollToElement from '../../../../helpers/scrollToElement';

interface FacetsCategoryProps {
  facet: FacetData;
}

function FacetsCategory({ facet }: FacetsCategoryProps): React.ReactElement {
  const [{ breadcrumbs, rid }] = useContext(ListerContext);
  const { selectFacet } = useListerApi();

  const facetSelectionHandler = (facetValue: FacetValueData, facetData: FacetData): void => {
    if (!facetValue.selected && !facetData.priceFacet) {
      attraqtTracker({
        action: Activities.CLICK,
        target: { facet: facetData.facetId, [facetData.facetId]: facetValue.name },
        sourceId: rid
      });
    }

    selectFacet(facetValue.selected ? getRemoveQuery(facetValue.code) : facetValue.query.location);

    function getRemoveQuery(code: string): string {
      return breadcrumbs.find(({ facetValueCode }) => facetValueCode === code)?.removeQuery.location || '';
    }

    ScrollToElement('listerRoot');
  };

  return (
    <div className={classnames(styles['facets-category'], 'rolex-spacing-30')}>
      <div className="rolex-spacing-20">
        <span className="rolex-title rolex-title--sm">{facet.name}</span>
      </div>
      <ul>
        {facet.values.map((value) => (
          <li key={value.code}>
            <Facet facet={facet} facetSelectionHandler={facetSelectionHandler} facetValueData={value} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FacetsCategory;
